import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { EmpresasAfiliadas } from '../models/empresasAfiliadas';
import { environment } from 'src/environments/environment';
import { Usuario } from '../models/usuario';
import { FormGroup } from '@angular/forms';
import { EmpresaConfiguracionInicial } from '../models/empresaAfiliadas/empresaAfiliadaUsuario';
import { HttprService } from '../shared/httpr.service';
import { BodyPerson_EmpresaAfiliada, BodyPerson_Proyectos, BodyPerson_PreguntasDinamicasPerfil, BodyPerson_RespuestasDinamicasPerfil, BodyPerson_MotivosDeCompraDinamicasPerfil } from '../models/bodyPerson';
import { rejects } from 'assert';

@Injectable({ providedIn: 'root' })
export class EmpresaAfiliadaService {
  usuarioLogeado: Usuario;
  constructor(private http: HttpClient, private httpr: HttprService) { }

  recuperaEmpresasAfiliadasV2(empresaAfiliada: EmpresasAfiliadas) {
    const usLogData = localStorage.getItem("usLog");
    this.usuarioLogeado = usLogData ? JSON.parse(usLogData) : null;

    if (!this.usuarioLogeado || !this.usuarioLogeado.token) {
      console.error('❌ No se encontró token en localStorage para recuperaEmpresasAfiliadasV2');
      return throwError({ message: 'Token no disponible', status: 401 });
    }

    var url = environment.apiUrl;

    let params = new HttpParams();
    params = params.append("IdEmpresaAfiliada", empresaAfiliada.idEmpresaAfiliada.toString());
    params = params.append("IdEmpresa", empresaAfiliada.idEmpresa.toString());
    params = params.append("Nombre", empresaAfiliada.nombre.toString());
    params = params.append("NombreComercial", empresaAfiliada.nombreComercial.toString());
    params = params.append("IdGrupo", empresaAfiliada.idGrupo.toString());
    params = params.append("IdUsuario", empresaAfiliada.idUsuario.toString());
    params = params.append("IdUsuarioUM", empresaAfiliada.idUsuarioUM.toString());

    return this.http.get<EmpresasAfiliadas>((url + "/empresasAfiliadas/recuperaEmpresasAfiliadasV2"), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }, params: params
    }).pipe(
      catchError(errorRes => {
        console.error('❌ Error en recuperaEmpresasAfiliadasV2:', errorRes);
        return throwError(errorRes);
      })
    );
  }


  recuperaEmpresasAfiliadasListV2(empresaAfiliada: EmpresasAfiliadas) {
    const usLogData = localStorage.getItem("usLog");
    this.usuarioLogeado = usLogData ? JSON.parse(usLogData) : null;

    if (!this.usuarioLogeado || !this.usuarioLogeado.token) {
      console.error('❌ No se encontró token en localStorage para recuperaEmpresasAfiliadasListV2');
      return throwError({ message: 'Token no disponible', status: 401 });
    }

    var url = environment.apiUrl;

    let params = new HttpParams();
    params = params.append("IdEmpresaAfiliada", empresaAfiliada.idEmpresaAfiliada.toString());
    params = params.append("IdEmpresa", empresaAfiliada.idEmpresa.toString());
    params = params.append("Nombre", empresaAfiliada.nombre.toString());
    params = params.append("NombreComercial", empresaAfiliada.nombreComercial.toString());
    params = params.append("IdGrupo", empresaAfiliada.idGrupo.toString());
    params = params.append("IdUsuario", empresaAfiliada.idUsuario.toString());
    params = params.append("IdUsuarioUM", empresaAfiliada.idUsuarioUM.toString());

    return this.http.get<EmpresasAfiliadas[]>((url + "/empresasAfiliadas/recuperaEmpresasAfiliadasV2"), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado.token}`
      }, params: params
    }).pipe(
      catchError(errorRes => {
        console.error('❌ Error en recuperaEmpresasAfiliadasListV2:', errorRes);
        return throwError(errorRes);
      })
    );
  }

  async guardaEmpresaAfiliada(form: FormGroup, logo: File) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    const formData: any = new FormData();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.usuarioLogeado?.token}`);
    var url = environment.apiUrl;

    formData.append('logo', form.controls['imagen'].value);
    formData.append('IdUsuarioUM', this.usuarioLogeado != null ? this.usuarioLogeado.idUsuario.toString() : 98);
    formData.append('Nombre', form.value?.nombre);
    formData.append('Direccion', form.value?.direccion);
    formData.append('Experiencia', form.value?.experiencia == null ? 0 : form.value?.experiencia);
    formData.append('CantidadProyectos', form.value?.proyectos == null ? 0 : form.value?.proyectos);
    formData.append('Latitud', form.value?.latitud == null ? 0 : form.value?.latitud);
    formData.append('Longitud', form.value?.longitud == null ? 0 : form.value?.longitud);

    return this.http.post<EmpresasAfiliadas>(url + "/empresasafiliadas/guarda-empresaV2", formData, { headers }).pipe(map((data: EmpresasAfiliadas) => {
      return data;
    }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    ).toPromise();
  }

  recuperaEmpresaUsuarioPendiente(correo: string, telefono: string) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))

    var url = environment.apiUrl;

    let params = new HttpParams();
    params = params.append("Correo", correo);
    params = params.append("Telefono", telefono);

    return this.http.get<EmpresasAfiliadas>((url + "/empresasAfiliadas/recuperaEmpresaUsuarioPendiente"), {
      headers: {
        'Content-Type': 'application/json',
      }, params: params
    }).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  guardaConfiguracionInicial(empresaConfiguracionInicial = new EmpresaConfiguracionInicial()) {
    return this.httpr.POST<any>("/empresasAfiliadas/guarda-empresaAfiliada-configuracionInicial", empresaConfiguracionInicial);
  }

  recuperarConfiguracionInicial(empresaConfiguracionInicial = new EmpresaConfiguracionInicial()) {
    let params = new HttpParams();
    params = params.append("IdEmpresaAfiliada", empresaConfiguracionInicial.idEmpresaAfiliada.toString());

    return this.httpr.GET<any>("/empresasAfiliadas/recupera-empresaAfiliada-configuracionInicial", params);
  }

  recuperaBodyPersonPersonalizados(bodyPerson: BodyPerson_EmpresaAfiliada) {
    return this.httpr.POST<any>("/empresasAfiliadasBS/recupera-bodyPerson-personalizado-EmpresaAfiliada", bodyPerson);
  }

  async guardarBodyPerson(bodyPerson_EmpresaAfiliada: BodyPerson_EmpresaAfiliada): Promise<any> {
    return new Promise((resolve) => {
      this.httpr.POST<any>("/empresasAfiliadasBS/guarda-bodyPerson-EmpresaAfiliada", bodyPerson_EmpresaAfiliada)
        .subscribe(
          (data) => resolve(data),
          (error) => rejects(error)
        );
    });
  }

  async guardarBodyPersonProyectos(bodyPerson_Proyectos: BodyPerson_Proyectos): Promise<any> {
    return new Promise((resolve) => {
      this.httpr.POST<any>("/empresasAfiliadasBS/guarda-bodyPerson-Proyectos", bodyPerson_Proyectos)
        .subscribe(
          (data) => resolve(data),
          (error) => rejects(error)
        );
    });
  }

  async guardarBodyPreguntasDinamicas(bodyPerson_PreguntasDinamicasPerfil: BodyPerson_PreguntasDinamicasPerfil): Promise<any> {
    return new Promise((resolve) => {
      this.httpr.POST<any>("/empresasAfiliadasBS/guarda-bodyPerson-PreguntasDinamicasPerfil", bodyPerson_PreguntasDinamicasPerfil)
        .subscribe(
          (data) => resolve(data),
          (error) => rejects(error)
        );
    });
  }

  async guardarBodyRespuestasDinamicas(bodyPerson_RespuestasDinamicasPerfil: BodyPerson_RespuestasDinamicasPerfil): Promise<any> {
    return new Promise((resolve) => {
      this.httpr.POST<any>("/empresasAfiliadasBS/guarda-bodyPerson-RespuestasDinamicasPerfil", bodyPerson_RespuestasDinamicasPerfil)
        .subscribe(
          (data) => resolve(data),
          (error) => rejects(error)
        );
    });
  }

  recuperaBodyPersonCompleto(idBodyPerson: number, idProyecto: number) {
    let params = new HttpParams();
    params = params.append("IdBodyPerson", idBodyPerson.toString());
    params = params.append("IdProyecto", idProyecto.toString());

    return this.httpr.GET<any>("/empresasAfiliadasBS/recupera-bodyPerson-perfil-completo", params);
  }

  guardarBodyPersonMotivosCompra(bodyPerson_MotivosCompra: BodyPerson_MotivosDeCompraDinamicasPerfil): Promise<any> {
    console.log("Body person motivos compra", bodyPerson_MotivosCompra);
    return new Promise((resolve) => {
      this.httpr.POST<any>("/empresasAfiliadasBS/guarda-bodyPerson-motivosDeCompraDinamicasPerfil", bodyPerson_MotivosCompra)
        .subscribe(
          (data) => resolve(data),
          (error) => rejects(error)
        );
    });
  }
}
